export const GRID_COLUMNS = "13% 11% 11% 7% 8% 7% 5% 5% 10% 4% 10% 9%";
